import { Formik, Form as FormikForm, type FormikConfig, type FormikValues } from 'formik';
import type { ReactNode } from 'react';

interface FormProps<T extends FormikValues> extends FormikConfig<T> {
  children: ReactNode;
}

export function Form<T extends FormikValues>({
  initialValues,
  onSubmit,
  validationSchema,
  enableReinitialize,
  children,
}: FormProps<T>) {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize={enableReinitialize}
    >
      {() => <FormikForm>{children}</FormikForm>}
    </Formik>
  );
}

export default Form;
